import { render } from "./GeographicInfo.vue?vue&type=template&id=06eecf26&scoped=true"
import script from "./GeographicInfo.vue?vue&type=script&lang=js"
export * from "./GeographicInfo.vue?vue&type=script&lang=js"

import "./GeographicInfo.vue?vue&type=style&index=0&id=06eecf26&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eecf26"]])

export default __exports__